const PAGEVIEW_ATTRIBUTES = {
  id: "modules/analytics/schema/pageviewAttributes",
  type: "object",
  properties: {
    page_url: {
      type: "string",
    },
    page_path: {
      type: "string",
    },
    page_title: {
      type: "string",
    },
    query_params: {
      type: "object",
    },
    custom: {
      type: "object",
    },
  },
  required: ["page_url", "page_path"],
}

export default PAGEVIEW_ATTRIBUTES
